export enum AFMType {
Greek,
EU,
Individual,
OutEU,
}
